// extracted by mini-css-extract-plugin
export default {"banner":"HomeBanner_banner__DRpO6","banner__bgImg":"HomeBanner_banner__bgImg__oSi3v"};